export default "__VITE_ASSET__5YldaAzx__"